<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 230px">
        <p>业务名称：</p>
        <el-input v-model="businessIpt" size="mini" style="width:150px" placeholder="请输入委托商名称"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>评审类型：</p>
        <el-select v-model="reviewIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in reviewOption" :key="item.id" :label="item.classaName" :value="item.id"/>
        </el-select>
      </div>
      <div class="navContainer" style="width: 480px">
        <p>创建时间：</p>
        <el-date-picker
          v-model="timeIpt"
          size="mini"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"/>
      </div>
      <div class="navContainer" style="width: 230px">
        <p>审核状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          stripe
          border
          :header-cell-style="{'color':'#7F7F7F','font-size':'13px','height':'48px',}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="businessName" label="业务名称" align="center"/>
          <el-table-column prop="reviewTypeShow" label="评审类型" width="199" align="center"/>
          <el-table-column prop="createTime" label="创建时间" align="center">
            <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
          </el-table-column>
          <el-table-column prop="stateShow" label="审核状态" align="center" width="100%">
            <!-- <div slot-scope="scope">{{getState(scope.row.examine,scope.row.operationPower)}}</div> -->
          </el-table-column>
          <el-table-column prop="operateType" label="操作类型" align="center" width="100%">
            <!-- <div slot-scope="scope">{{operationTypeFormat(scope.row.operationType)}}</div> -->
          </el-table-column>
          <el-table-column label="操作" width="205" align="center">
            <template slot-scope="scope">
              <!-- <div style="display:flex;align-items:center;padding-left: 10px"> -->
              <div style="align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id,scope.row.operationPower)">详情</el-button>
                <el-button v-if="scope.row.examine===1 && scope.row.operationPower===1" size="mini" type="primary" @click="enableClick(scope.row.id)">同意</el-button>
                <el-button v-if="scope.row.examine===1 && scope.row.operationPower===1" size="mini" type="danger" @click="disableClick(scope.row.id)">拒绝</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情价格评审" :visible.sync="detailDialogVisible" width='600px' center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
            <p :style="getStyle(detailData.state)">{{detailData.stateShow}}</p>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">业务名称：</span>
              <span>{{detailData.businessName}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">评审类型：</span>
              <span>{{detailData.reviewTypeShow}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">评审需求：</span>
              <span>{{detailData.reviewDemand}}</span>
            </div>
          </div>
        </div>
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>审核信息</span>
          </div>
          <steps :step-data="stepData" :step-state="stepState"/>
        </div>
        <div class="baseInfo" v-if="detailData.operationPower===1 && detailData.examine===1">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>操作</span>
          </div>
          <div class="baseInfoContentItem">
            <div style="display: flex;margin:10px 20px 0 15px;">
              <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>
              <el-input
                type="textarea"
                :style="'width:100%'"
                v-model="remark"
                placeholder="请填写同意/拒绝原因"
                autocomplete="off"
                size="small"
              />
            </div>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center" v-if="detailData.operationPower===1 && detailData.examine===1">
          <el-button size="medium" type="primary" @click="agreeClick">同意</el-button>
          <el-button size="medium" type="danger" @click="refusedClick">拒绝</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="reasonTitle" :visible.sync="reasonVisible" width='550px' center :close-on-click-modal="false" top="30vh">
      <div class="reasonContainer">
        <div style="display: flex;padding-bottom: 20px;">
          <span class="span1" style="width: 70px;"><span style="color:red">*</span>原因：</span>
          <el-input
            type="textarea"
            style="width:100%;"
            v-model="reason"
            :placeholder="`请填写${reasonTitle}`"
            autocomplete="off"
            size="small"
          />
        </div>
        <div class="reasonBtn">
          <el-button size="medium" class="searchBtn" type="primary" @click="reasonClick">确认</el-button>
          <el-button size="medium" class="resetBtn" type="danger" @click="reasonVisible=false">取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import steps from "@/components/steps";
import {
  auditPageList,
  busiPriceReviewType,
  priceReviewDetail,
  reviewSubmit,
} from "@/service/audit"
import {formatDateTime} from "@/config/mUtils";

export default {
  components: {
    steps,
  },
  data() {
    return {
      businessIpt:'',
      reviewIpt:'',
      timeIpt:'',
      stateIpt:'',
      stateOption:[
        {value:'',label:'全部',},
        {value:1,label:'待审核'},
        {value:2,label:'已通过'},
        {value:3,label:'未通过'},
        {value:4,label:'已取消'},
      ],
      activeId:'',
      reviewOption:[],
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      detailDialogVisible:false,
      detailData:{},
      remark:'',
      stepData:[
        {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
        {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
        {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
      ],
      reasonVisible:false,
      reasonTitle:'',
      reason:'',
    };
  },
  computed:{
    stepState(){
      return function(state){
        switch(state) {
          case '':
            return 'wait'
          case 'success':
            return 'success'
          case 'failure':
            return 'error'
        }
      };
    },
    getStyle() {
      return (val) => {
        switch (val) {
          case 2:
            return 'color: rgba(51, 136, 255, 1);'
          case 1:
            return 'color: rgba(249, 166, 6, 1)'
          case 3:
            return 'color:#F56C6C;'
          case 4:
            return 'color:#F56C6C;'
        }
      }
    },
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
    // 审核状态
    getState(){
      return function(state,operationPower){
        switch(true) {
          case operationPower ===0:
            return '已通过'
          case state ===1 &&operationPower ===1:
            return '待审核'
          case state ===2 &&operationPower ===1:
            return '已通过'
          case state ===3 &&operationPower ===1:
            return '已拒绝'
          case state ===4 &&operationPower ===1:
            return '已取消'
        }
      };
    },
    //操作类型
    operationTypeFormat(){
      return function (value) {
        switch(value) {
          case 1:
            return '新增'
          case 2:
            return '信息变更'
          case 3:
            return '终止合作'
        }
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this._auditPageList();
      const res = await busiPriceReviewType({categoryCd:'contract_price'});
      if(res.status !== 0) this.$message.error(res.message);
      else this.reviewOption=[{id:'',classaName:'全部'},...res.data];
    },
    async _auditPageList(){
      this.tableLoad=true;
      const res = await auditPageList(
        {
          businessName:this.businessIpt,
          state:this.stateIpt,
          reviewType:this.reviewIpt,
          startTime:this.timeIpt[0]?this.timeIpt[0]:'',
          endTime:this.timeIpt[1]?this.timeIpt[1]:'',
          rows:this.size,
          page:this.page,
        }
      );
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total;
    },
    async refusedClick(){
      this.remark=this.remark.trim();
      if(!this.remark) return this.$message.warning('请填写拒绝理由！');
      const res = await reviewSubmit(
        {
          id:this.activeId,
          auditOpinion:this.remark,
          reviewResult:'REFUSE',
        }
      );
      if(res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.detailDialogVisible=false;
      await this._auditPageList();
    },
    async agreeClick(){
      this.remark=this.remark.trim();
      if(!this.remark) return this.$message.warning('请填写同意理由！');
      const res = await reviewSubmit(
        {
          id:this.activeId,
          auditOpinion:this.remark,
          reviewResult:'AGREE',
        }
      );
      if(res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.detailDialogVisible=false;
      await this._auditPageList();
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._auditPageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._auditPageList();
    },
    disableClick(id){
      this.$confirm('确认拒绝当前培训计划申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reason='';
        this.activeId=id;
        this.reasonTitle='拒绝原因';
        this.reasonVisible=true;
      }).catch(() => {});
    },
    async detailClick(id){
      this.remark='';
      this.detailDialogVisible=true;
      const res = await priceReviewDetail({id});
      if(res.status !== 0) return this.$message.error(res.message);
      this.detailData=res.data;
    },
    searchBtn(){
      this.page = 1;
      this._auditPageList();
    },
    resetBtn(){
      this.businessIpt='';
      this.reviewIpt='';
      this.timeIpt='';
      this.stateIpt='';
    },
    enableClick(id){
      this.$confirm('确认同意当前培训计划申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.reason='';
        this.activeId=id;
        this.reasonTitle='同意原因';
        this.reasonVisible=true;
      }).catch(() => {});
    },
    async reasonClick(){
      this.reason=this.reason.trim();
      if(!this.reason) return this.$message.warning(this.reasonTitle==='同意原因'?'请填写同意原因！':'请填写拒绝原因!');
      const res = await reviewSubmit(
        {
          id:this.activeId,
          auditOpinion:this.reason,
          reviewResult:this.reasonTitle==='同意原因'?'AGREE':'REFUSE',
        }
      );
      if(res.status !== 0) return this.$message.error(res.message);
      this.$message.success(res.message);
      this.reasonVisible=false;
      await this._auditPageList();
    },
  },
};
</script>



<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 30px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-badge__content{
          top: 4px !important;
          right: 1px !important;
        }
        .el-badge__content{
          background-color: #F56C6C !important;
        }
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  .reasonContainer{
    width:100%;
    padding: 20px 30px;
    ::v-deep{
      .el-textarea__inner{
        min-height: 100px!important;
      }
    }
    .reasonBtn{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content:flex-end;
    }
  }
  .company{
    width:100%;
    padding: 20px 10px;
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-input__inner{
        border: none;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
    .btnContainer{
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      button{
        margin: 0 15px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
